import cx from 'classnames'

export const ModalFooter = ({ children, className, ...props }) => (
  <div className={cx('tw:flex tw:items-center tw:gap-2 tw:border-t tw:border-default tw:bg-surface-muted tw:px-5 tw:py-4', className)} {...props}>{children}</div>
)
